import { MainAppRoute } from "@/rootRoutes/MainApp"
import { manageAccessToken } from "@/utils/Auth/Session"
import { AuthenticateUserResp } from "../Authentication/AuthUtils/Login"
import { Route, useParams } from "@tanstack/react-router"
import { usePDF } from "react-to-pdf"
import HeaderComponent from "@/components/Header/Header"
import CandidateProfile from "../ProfileV2/components/candidate-profile"
import { useGetInstantmatchProfileApplicantId } from '../../../openapi/api/endpoints/default/default';

const InstantMatchCandidateProfile = () => {
    const { applicationId, hiringCampaignId } = useParams({
        from: "/allCampaigns/$hiringCampId",
      });
    const {data:candidate, isLoading}=useGetInstantmatchProfileApplicantId(applicationId,{
        hiringCampaignId
    })
    const { toPDF, targetRef } = usePDF({ filename: `${candidate?.firstName}_${candidate?.lastName}_profile.pdf` })
  
    if(isLoading){
      return <div>Loading...</div>
    }
    if(!candidate){
      return <div>No data</div>
    }
    if(candidate){
    console.log({candidate})
    }
  
    return (
      <div className="min-h-screen bg-gray-100 py-8">
          <HeaderComponent title='Applicant Summary'/>
          <div ref={targetRef}>
            <CandidateProfile candidate={candidate} onDownload={() => toPDF()} />
          </div>
      </div>
    )
}

const InstantMatchProfileRoute = new Route({
    getParentRoute: () => MainAppRoute,
    path: "/allCampaigns/$hiringCampaignId/instantMatch/$applicationId",
    component: InstantMatchCandidateProfile,
    beforeLoad:async ({context:{auth,queryClient}})=>{
      const session=await manageAccessToken({AuthPayload:auth as AuthenticateUserResp})
      if(!session){//no token means that token is still good
        return
      }
      const newAuthPayload={
        ...auth,
          session
        } as AuthenticateUserResp
      queryClient.setQueryData(['Auth'],newAuthPayload)
      return {
        auth:newAuthPayload
      }
    },
    })
export default InstantMatchProfileRoute;